import {
  IllustrationIdApi,
  isGettedIllustrationIdDTO,
} from "../Illustration/IllustrationId";
import { IllustrationApi } from "../Illustration/Illustration";

export interface TaskIllustrationIdApi {
  taskIllustrationId: string;
}

export interface TaskIllustrationApi {
  illustration: IllustrationApi;
}

export interface OptionalTaskIllustrationIdApi {
  taskIllustrationId?: string;
}

export type TaskIllustrationIdsDTOType = IllustrationIdApi &
  TaskIllustrationIdApi;

export type TaskIllustrationIdsWithOptionalTaskIllustrationIdDTOType =
  IllustrationIdApi & OptionalTaskIllustrationIdApi;

export let isGettedIllustrationIdsWithOptionalTaskIllustrationIdDTO = (
  variable: unknown
): variable is TaskIllustrationIdsDTOType => {
  return (
    isGettedIllustrationIdDTO(variable) &&
    (!("taskIllustrationId" in variable) ||
      typeof variable.taskIllustrationId === "string")
  );
};

export let isGettedTaskIllustrationIdDTO = (
  variable: unknown
): variable is TaskIllustrationIdApi => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "object" &&
    "taskIllustrationId" in variable &&
    typeof variable.taskIllustrationId === "string"
  );
};

export let isGettedTaskIllustrationIdsDTO = (
  variable: unknown
): variable is TaskIllustrationIdsDTOType => {
  return (
    isGettedIllustrationIdDTO(variable) &&
    isGettedTaskIllustrationIdDTO(variable)
  );
};

export type TaskIllustrationDTOType = TaskIllustrationIdsDTOType &
  TaskIllustrationApi;
